// action - state management
import { LOGIN, LOGOUT, REGISTER } from './actions';

const initialState = {
  isLoggedIn: false,
  isInitialized: false,
  user: null
};

export default function accountReducer(state = initialState, action) {
  switch (action.type) {
    case REGISTER: {
      const { user } = action.payload;
      return {
        ...state,
        user
      };
    }
    case LOGIN: {
      const { user } = action.payload;
      return {
        ...state,
        isLoggedIn: true,
        isInitialized: true,
        user
      };
    }
    case LOGOUT: {
      return {
        ...state,
        isInitialized: true,
        isLoggedIn: false,
        user: null
      };
    }
    default: {
      return { ...state };
    }
  }
}
